import { AnyObject, yup } from '@framework/validation';
import { isEqual } from 'lodash';
import { useEffect } from 'react';
import { useFormContext } from 'react-hook-form';

export interface IAdvancedSearchQueryValuesSetterProps {
  query: AnyObject | undefined | null;
  schema: yup.ObjectSchema<AnyObject>;
}

export function AdvancedSearchQueryValuesSetter(
  props: IAdvancedSearchQueryValuesSetterProps,
) {
  const methods = useFormContext();
  useEffect(() => {
    const nextValues = props.schema.cast(props.query, { assert: false });
    if (!isEqual(nextValues, methods.getValues())) {
      methods.reset(nextValues, { keepDefaultValues: false });
    }
  }, [props.query]);

  return null;
}
